import { generatePath } from 'react-router-dom';

import { channelAgentNameFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/channelAgentNameFieldColumn';
import { toDealDetailFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/toDealDetailFieldColumn';
import { updatedAtFieldColumn } from '@/components/modules/_shared/utils/DataGridFields/updatedAtFieldColumn';
import { articleTypeFieldColumn } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/assetTypeFieldColumn';
import { checkoutSessionBorrowerNameFieldColumn } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/checkoutSessionBorrowerNameFieldColumn';
import { checkoutSessionDetailsColumn } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/checkoutSessionDetailsColumn';
import { selectedPaymentIntentColumn } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/selectedPaymentIntentColumn';
import { statusFieldColumn } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/desktop/statusFieldColumn';
import { orderRefsWithPrincipalAmountMobile } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/mobile/orderRefsWithPrincipalAmountMobile';
import { updatedAtWithCustomerNameFieldColumnMobile } from '@/components/modules/CheckoutSession/List/utils/getDataGridFields/components/mobile/updatedAtWithCustomerNameFieldColumnMobile';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { ApplicationType } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';
import { useUser } from '@/hooks/useUser';

export function checkoutSessionDataGridFields() {
  const { sm, md } = useScreen();
  const { userEntity } = useUser();

  const isAdmin = userEntity?.isRoleAdminOrSuperAdmin();

  const linkTo = (id: string) => generatePath(DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_DETAIL, { checkoutSessionId: id });

  const defaultCheckoutSessionFields = {
    desktop: [
      articleTypeFieldColumn({ flex: 0.1 }),
      checkoutSessionBorrowerNameFieldColumn({ flex: 0.28 }),
      channelAgentNameFieldColumn({ flex: 0.32 }),
      checkoutSessionDetailsColumn({ flex: 0.22 }),
      updatedAtFieldColumn({ flex: 0.28 }),
      selectedPaymentIntentColumn({ flex: 0.5 }),
      ...(isAdmin
        ? [
            statusFieldColumn({
              flex: 0.23,
              applicationType: ApplicationType.CHECKOUT_SESSION,
              headerTextId: 'CHECKOUT_SESSION_STATUS',
            }),
          ]
        : []),
      toDealDetailFieldColumn({ linkTo, flex: 0.15 }),
    ],
    mobile: [
      updatedAtWithCustomerNameFieldColumnMobile({ flex: 0.3 }),
      ...(sm ? [orderRefsWithPrincipalAmountMobile({ flex: 0.3 })] : []),
      selectedPaymentIntentColumn({ flex: 0.6 }),
    ],
  };

  const DataGridFields = {
    checkout_session: defaultCheckoutSessionFields.desktop,
  };

  const MobileDataGridFields = {
    checkout_session: defaultCheckoutSessionFields.mobile,
  };

  return md ? DataGridFields['checkout_session'] : MobileDataGridFields['checkout_session'];
}
